<template>
  <div
    class="ts-text-blue-700 ts-flex ts-justify-between ts-float-right"
    style="min-width: 100px;"
  >
    <b>{{ displaySymbol() }}</b>
    <b>{{ displayAmount() }}</b>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'displayConverter',
  props: {
    amount: { type: Number, default: 0 },
    currency_id: { type: Number }
  },
  data() {
    return {}
  },
  mounted() {
    this.getPreData({
      params: {},
      index: undefined
    })
  },
  computed: {
    ...mapState('exchangeRate/currency', ['formViewDatas']),
    currencies() {
      if (this.formViewDatas['currencies']) {
        return this.formViewDatas['currencies'].map(el => ({
          value: el.currency_id,
          label: el.currency_symbol,
          currency_code: el.currency_code,
          currency_rounding: el.currency_rounding,
          fx_rate: el.last_exchange_rate ? el.last_exchange_rate.fx_rate : 1,
          fx_rate_ratio: el.last_exchange_rate
            ? el.last_exchange_rate.fx_rate_ratio
            : 1
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('exchangeRate/currency', ['getFormViewModel']),
    async getPreData({ params, index }) {
      if (!this.formViewDatas['currencies']) {
        await this.getFormViewModel({
          index: index,
          params: {
            fnName: params
          }
        })
      }
    },
    displaySymbol() {
      const currency = this.currencies.find(el => el.value === this.currency_id)

      if (currency) {
        return `${currency.label}`
      }
      return ''
    },
    displayAmount() {
      const currency = this.currencies.find(el => el.value === this.currency_id)

      if (currency) {
        const fromAmount = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: currency.currency_rounding,
          maximumFractionDigits: currency.currency_rounding
        }).format(this.amount)

        return `${fromAmount}`
      }
      return ''
    }
  }
}
</script>
